import { Controller } from "@hotwired/stimulus";
import { TypedController } from "@vytant/stimulus-decorators";

@TypedController
export default class extends Controller {
  connect() {
    this.element.querySelectorAll<HTMLInputElement>("#tabs > label").forEach((input) => {
      input.addEventListener("mouseenter", (event) => {
        const tabValue = (event.target as HTMLDivElement).querySelector("input")?.value;
        if (!tabValue) return;

        const tabContent = this.element.querySelector<HTMLDivElement>(`[data-id="${tabValue}"] > iframe`) as HTMLIFrameElement | null;
        if (tabContent) {
          tabContent.loading = "eager";
        }
      });
    });

    this.element.querySelectorAll<HTMLIFrameElement>("iframe").forEach((iframe) => {
      iframe.addEventListener("load", () => {
        const tabContent = iframe.parentElement as HTMLDivElement;
        if (!tabContent) return;

        tabContent.classList.remove("loading");
      });
    });
  }
}
